export default function About() {
  return (
    <section className="py-24 md:py-32 bg-brand-bg" data-testid="about-section">
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <p className="text-xs font-medium tracking-[0.25em] text-brand-olive uppercase mb-4">Chi siamo</p>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-2">
            <div className="aspect-square rounded-2xl overflow-hidden border border-brand-line bg-brand-bg2 flex items-center justify-center">
              <img
                src="/robs.png"
                alt="robS, fondatore di 24Vox"
                className="w-full h-full object-contain"
                data-testid="founder-photo"
              />
            </div>
          </div>
          <div className="md:col-span-3">
            <h2 className="font-heading text-4xl md:text-5xl text-brand-ink mb-6 leading-tight">
              Sono <span className="text-brand-terra italic">robS</span>,<br />
              fondatore di 24Vox.
            </h2>
            <p className="text-lg text-brand-inkSoft leading-relaxed mb-6" data-testid="founder-bio">
              Ho passato 18 mesi a costruire AI che parlano come persone, non come centralini.
            </p>
            <p className="text-lg text-brand-ink leading-relaxed">
              Hai una domanda, vuoi capire se fa per te, o vuoi semplicemente saperne di più? Scrivimi a{" "}
              <a href="mailto:robs@24vox.it" className="text-brand-olive font-medium underline underline-offset-4 hover:text-brand-oliveDark transition-colors" data-testid="founder-email-link">
                robs@24vox.it
              </a>{" "}
              — rispondo io, non un commerciale.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
